import type { ComponentStyleConfig } from '@chakra-ui/theme';

const DialogTheme: ComponentStyleConfig = {
  baseStyle: ({ scrollBehavior }) => ({
    body: {
      flex: 1,
      overflow: scrollBehavior === 'inside' ? 'auto' : undefined,
      paddingX: '32',
    },
    closeButton: {
      color: 'purple.10',
      position: 'absolute',
      right: '22',
      top: '22',
    },
    dialog: {
      backgroundColor: 'neutral.100',
      borderRadius: '8',
      boxShadow: 'large',
      marginY: '10vh',
      maxH: scrollBehavior === 'inside' ? '80vh' : undefined,
    },
    dialogContainer: {
      alignItems: 'flex-start',
      display: 'flex',
      justifyContent: 'center',
      overflow: scrollBehavior === 'inside' ? 'hidden' : 'auto',
      zIndex: 'dialog',
    },
    footer: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '16',
      justifyContent: 'end',
      padding: '32',
      paddingTop: '48',
    },
    header: {
      color: 'purple.10',
      padding: '24',
      paddingLeft: '30',
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, .5)',
      zIndex: 'dialogOverlay',
    },
  }),
  sizes: {
    full: {
      dialog: {
        bottom: '32',
        left: '32',
        margin: '0',
        maxH: 'auto',
        position: 'absolute',
        right: '32',
        top: '32',
        width: 'auto',
      },
      dialogContainer: {
        zIndex: 'fullDialog',
      },
      overlay: {
        zIndex: 'fullDialogOverlay',
      },
    },
    large: {
      dialog: {
        maxWidth: '50rem',
      },
    },
    medium: {
      dialog: {
        maxWidth: '40rem',
      },
    },
    mobile: {
      dialog: {
        '@supports(min-height: -webkit-fill-available)': {
          maxH: '-webkit-fill-available',
        },
        borderRadius: 0,
        marginY: '0',
        maxH: '100vh',
        w: '100vw',
      },
    },
    small: {
      dialog: {
        maxWidth: '30rem',
      },
    },
  },
};

export default DialogTheme;
